import React from 'react';
import Button from 'b2b-ui-components-lib/lib/components/button';
import { isBulkUpgrade } from 'common/constants/app.constants';

import './index.scss';
import { getDownloadText, getSampleFileName } from 'home/view/check-feasibility/comp-generator/component.generator';

const DownloadComponent = ({
  heading = 'Export Excel Configuration File',
  subHeading = 'Download the feasible sites, configure it offline and upload the file here.',
  btnName = '',
  onClick = () => {},
  isDrawerModal = false,
  sampleFileName = getSampleFileName(),
  additionalText = getDownloadText(),
  loading = false
}) => {
  const getDefaultDownloadComponent = () => {
    if (isBulkUpgrade()) {
      return (
        <div className="config_content">
          <p>{additionalText} </p>
          {sampleFileName && (
            <div className="config_button mt-l">
              <Button onClick={onClick} disabled={loading}>
                {sampleFileName}
                <span
                  className="material-icons-outlined"
                  style={{
                    top: 2,
                    left: 10
                  }}
                >
                  file_download
                </span>
                {loading && <span className="loading_icon"></span>}
              </Button>
            </div>
          )}
        </div>
      );
    }

    return (
      <div className="download_info">
        <div className="smaple_doc" role="button" aria-label="Download Sample.xls" onClick={onClick}>
          <span className="sample_docs_name">{sampleFileName}</span>
          <span className="material-icons">download</span>
        </div>
        {additionalText}
      </div>
    );
  };

  return isDrawerModal ? (
    <div className="config_content">
      <h5>{heading} </h5>
      <p>{subHeading} </p>
      {btnName && (
        <div className="config_button">
          <Button onClick={onClick} disabled={loading}>
            {btnName}
            <span
              className="material-icons-outlined"
              style={{
                top: 2,
                left: 10
              }}
            >
              file_download
            </span>
            {loading && <span className="loading_icon"></span>}
          </Button>
        </div>
      )}
    </div>
  ) : (
    getDefaultDownloadComponent()
  );
};

export default DownloadComponent;
